import {Routes} from "@angular/router";
import {AccessGuardCanActivate, AccessGuardCanMatchFn} from "./modules/auth/services/access.guard";

export const MainRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/routes').then(r => r.SecurityRoutes),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./pages/errors/routes').then((r) => r.ErrorsRoutes),
  },
  {
    path: '',
    canActivate: [AccessGuardCanActivate],
    loadChildren: () =>
      import('./_metronic/layout/layout.module').then((m) => m.LayoutModule),
  },
  {path: '**', redirectTo: 'error/404'},
];

export const LayoutModuleRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('../app/pages/dashboard/dashboard.component').then((c) => c.DashboardComponent),
  },
  {
    path: 'profile',
    canMatch: [AccessGuardCanMatchFn],
    loadChildren: () =>
      import('../app/_metronic/layout/components/_partials/profile/profile.module').then((c) => c.ProfileModule),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/user-management/routes').then((r) => r.UserManagementRoutes),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/group-management/routes').then((r) => r.GroupManagementRoutes),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/center-management/routes').then((r) => r.CenterManagementRoutes),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/patient-management/routes').then((r) => r.PatientManagementRoutes),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/professional-management/routes').then((r) => r.ProfessionalManagementRoutes),
  },
  {
    path: 'management',
    loadChildren: () =>
      import('../app/modules/administrator-center-management/routes').then((r) => r.AdministratorCenterRoutes),
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
